import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export const CustomTypography = ({ field, record, column }) => {
  const value = record[field]?.value ?? record[field];

  const className = column?.renderClassName || record[field]?.renderClassName;

  return <Typography className={className}>{value}</Typography>;
};

CustomTypography.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object,
  column: PropTypes.shape({
    className: PropTypes.string,
    renderClassName: PropTypes.string,
    totals: PropTypes.object,
    field: PropTypes.string
  })
};

export default CustomTypography;
